import React, { useEffect } from 'react';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { ThemeProvider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { MapProvider } from 'react-map-gl';
import { getRoute } from 'handimap-react-lib/api/handimapApi';

import './App.css';
import MapZone from 'handimap-react-lib/containers/MapZone';
import { SideBarContent } from './containers/SideBarContent';
import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';
import theme from './theme';
import i18n from './utils/i18n';
import { AlertNoti } from 'handimap-react-lib/components/Alert/AlertNoti';
import { setOpenDrawer } from 'handimap-react-lib/store/actions/sideBarActions';
import { I18nextProvider } from 'react-i18next';
import { LayersEngine } from 'handimap-react-lib/components/LayersEngine';
// import { callGetJson } from 'handimap-react-lib/api/jsonConfApi';
// import { openWelcomeModal } from 'handimap-react-lib/store/actions/modalActions';
import { baseMaps, extras } from './baseMap';
// import { setLegends } from 'handimap-react-lib/store/actions/legendActions';
import { HandleAlertNotiItinerary } from 'handimap-react-lib/components/Alert/HandleAlertNotiItinerary';
import { CreditSideBar } from 'handimap-react-lib/components/CreditSideBar';
import { convertProfilForApiVal, convertProfiltForApi } from './utils/profilConverter';
// import { WelcomeModal } from './containers/WelcomeModal';
import { HeaderLegends } from './containers/HeaderLegends';
import { SideBarContainer } from './containers/SideBarContainer';
import { BottomBarSection } from './containers/BottomBarSection';
import { PoiListingMenu } from './containers/PoiListingMenu';
import { LayerBarSectionMobile } from './containers/LayerBarSectionMobile';
import { MapFunctionContainer } from './containers/MapFunctionContainer';
import { LegendContainer } from './containers/LegendContainer';
import { UrlEngine } from 'handimap-react-lib/components/UrlEngine';
import { closePoiListingMenu } from 'handimap-react-lib/store/actions/poiListingActions';
import { DataModal } from './components/DataModal';
import { ModalZone } from 'handimap-react-lib/components/ModalZone';
import { ObstaclesEngine } from './components/ObstaclesEngine';
import { AccessLibreContainer } from './containers/AccessLibreContainer';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="right" ref={ref} {...props} />;
// });

// const TransitionRight = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });


function App() {

  const {isMobile} = useResponsive();

  // handle url params to fill origin and destination inputs
  // origin=-3.380118759727253,47.75755855083423&destination=-3.365463687506235,47.748446408159424&profil=Déficience motrice&condition=Fauteuil roulant manuel&multimodal=false&selectedPath=1
  const queryParams = new URLSearchParams(window.location.search);
  const originFromUrl = queryParams.get('origin');
  const destinationFromUrl = queryParams.get('destination');
  const profileFromUrl = queryParams.get('profil');
  const conditionFromUrl = queryParams.get('condition');
  const multimodalFromUrl = queryParams.get('multimodal');
  const selectedPathFromUrl = queryParams.get('selectedPath');
  const zoneFromUrl = queryParams.get('zone');
  const timeFromUrl = queryParams.get('time');

  const openWelcome = false; // useSelector(state => state.modalZone.welcome);
  const showDirections = useSelector(state => state.sideBar.open);
  const showDrawer = useSelector(state => state.sideBar.drawer);
  const showAlert = useSelector(state => state.alert.isOpen);
  const alertContent = useSelector(state => state.alert.content);
  const alertSeverity = useSelector(state => state.alert.severity);
  const alertTitle = useSelector(state => state.alert.title);
  const alertRole = useSelector(state => state.alert.role);
  const poiListingMenuState = useSelector(state => state.poiListingMenuReducer.open);
  const profil = useSelector(state => state.profils.profil);
  const condition = useSelector(state => state.profils.condition);
  const showLegend = useSelector(state => state.legendList.show);

  // const { t } = useTranslation();
  // const getLanguage = () => i18n.language || window.localStorage.i18nextLng;
  const dispatch = useDispatch();
  const {palette} = theme;

  const apiProfil = convertProfiltForApi(profil, condition);
  const apiProfilRoute = convertProfilForApiVal(profil, condition);
  const multimodal = useSelector(state => state.profils.multimodal);
  const dateSelected = useSelector(state => state.profils.time);
  const origin = [...useSelector(state => state.directions.origin.marker)];
  const destination = [...useSelector(state => state.directions.destination.marker)];

  const { 
    status, 
    allResults, 
    error,
    refetch 
  } = getRoute(apiProfilRoute, multimodal, origin, destination, dateSelected);


  const styles = {
    container : {
      display: 'flex', 
      flexDirection: 'column',
      maxHeight: '100vh'
    },
    sideBar: {
      boxShadow: '0px 5px 5px #888888',
      zIndex: isMobile ? null : '100',
      alignContent: 'center', 
      maxWidth: isMobile ? '100%' : '24.25em', 
      minWidth: isMobile ? '100vw' : 'max-content'
    },
    creditSidebar: {
      display: 'flex',
      width: '100%',
    },
    buttonMenu: {
      position: 'absolute', 
      top: 10, 
      left: 10, 
      zIndex: '100', 
      backgroundColor: palette.primary.main, 
      color: palette.primary.contrastText,
      '&:hover': {
        backgroundColor: palette.primary.contrastText,
        color: palette.primary.main
      }
    },
    mapContainer: {
      display: 'flex', 
      width: '100%', 
      height: '100%',
    },
    poiDrawer: {
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
      }
    }, 
    alertContainer : {
      display: 'flex',
      position: 'fixed',
      left: isMobile ? '50%' : '60%',
      top: '12%',
      transform:'translate(-50%, -50%)', 
      width: '80%',
      zIndex: 10000,
      justifyContent: 'center'
    }
  };


  useEffect(() => {
    if (origin.length > 0 && destination.length > 0) {
      refetch();
    }
  }, [i18n.language]);

  // useLayoutEffect(() => {
  //   if (zoneFromUrl !== null && zoneFromUrl !== undefined && zoneFromUrl !== '') {
  //     callGetJson('custom_zoom_zone_button.json').then(
  //       result => {
  //         const zoomByZone = Object.assign({}, ...result.map((x) => ({[x.zone]: x})));
  //         let zoneDes = zoomByZone[zoneFromUrl].textFrDesc;
  //         if (getLanguage()==='fr') {
  //           zoneDes = zoomByZone[zoneFromUrl].textFrDesc;
  //         } else if (getLanguage()==='en') {
  //           zoneDes = zoomByZone[zoneFromUrl].textEnDesc;
  //         }
  //         const zoneImage = zoomByZone[zoneFromUrl].image;
  //         const credits = zoomByZone[zoneFromUrl].credits;
  //         dispatch(openWelcomeModal(zoneFromUrl, zoneDes, zoneImage, credits));
  //       }
  //     );
  //   } else {
  //     callGetJson('custom_info_city.json').then(
  //       result => {
  //         dispatch(openWelcomeModal(`${t('welcome.title')} Hitinéraire – Lorient Agglomération`, result['app-present']));
  //        }
  //     );
  //   }
  //   dispatch(setLegends(['acc', 'part_acc', 'not_acc', 'not_spec']));
  //   /**
  //    * window.history.replaceState remove url params
  //    */
  //   window.history.replaceState({}, '', '/hitineraire');
  //   document.documentElement.lang = getLanguage();
  // }, []);
  
  return (
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <div className="App" style={styles.container}>
          {!openWelcome && (
            <HeaderLegends />
          )}
          {/* <WelcomeModal open={openWelcome} /> */}
          <ModalZone />
          <DataModal />
          {!isMobile && (
            <AccessLibreContainer />
          )}
          <MapProvider >
            <LayersEngine isMobile={isMobile}/>
            <UrlEngine
              origin={originFromUrl}
              destination={destinationFromUrl}
              profil={profileFromUrl}
              condition={conditionFromUrl}
              multimodal={multimodalFromUrl}
              selectedPath={selectedPathFromUrl}
              time={timeFromUrl}
            />
            <ObstaclesEngine />
            <HandleAlertNotiItinerary 
              status={status}
              allResults={allResults}
              error={error}
            />
            <Box sx={styles.mapContainer}>
              {showAlert && (
                <Box sx={styles.alertContainer}>
                  <AlertNoti 
                    content={alertContent} 
                    severity={alertSeverity} 
                    title={alertTitle} 
                    role={alertRole}
                  />
                </Box>
              )}
              {!openWelcome && (
                <MapFunctionContainer />
              )}
              <SideBarContainer
                open={!openWelcome}
                showSidebarMobile={showDirections}
              >
                <SideBarContent 
                  profileFromUrl={profileFromUrl}
                  conditionFromUrl={conditionFromUrl}
                  multimodalFromUrl={multimodalFromUrl}
                  selectedPathFromUrl={selectedPathFromUrl}
                  timeFromUrl={timeFromUrl}
                  styles={styles} 
                  isMobile={isMobile} 
                  convertProfiltForApi={(profil, condition) => convertProfiltForApi(profil, condition)}
                  status={status}
                  allResults={allResults}
                />
                <Box sx={styles.creditSidebar}>
                  <CreditSideBar />
                </Box>
              </SideBarContainer>
              <MapZone 
                withNavControl={false}
                baseMaps={baseMaps} 
                baseGraph={apiProfil} 
                extrasLayers={extras} 
                isMobile={isMobile} 
                originFromUrl={originFromUrl} 
                destinationFromUrl={destinationFromUrl} 
                zoneFromUrl={zoneFromUrl} 
                hiddenButtons={poiListingMenuState} 
                convertProfiltForApi={(profil, condition) => convertProfiltForApi(profil, condition)}
                status={status}
                allResults={allResults}
                dateSelected={dateSelected}
              />
              {!openWelcome && !poiListingMenuState &&  (
                <BottomBarSection allResults={allResults} status={status} />
              )}
              <Drawer 
                id="poi-disclosure"
                sx={styles.poiDrawer}
                aria-labelledby="modal-zone-title"
                role="dialog" 
                aria-modal="true"
                hideBackdrop={false}
                variant='persistent'
                anchor='right'
                open={poiListingMenuState && !openWelcome}
                onClose={() => {
                  dispatch(closePoiListingMenu());
                  dispatch(setOpenDrawer(false));
                }}
              >
                <PoiListingMenu isMobile={isMobile}/>
              </Drawer>
              <Drawer 
                id='layer_settings_mobile'
                sx={styles.poiDrawer}
                role="dialog" 
                aria-modal="true"
                anchor='right'
                open={!openWelcome && isMobile && showDrawer}
                onClose={() =>  dispatch(setOpenDrawer(false))}
              >
                <LayerBarSectionMobile />
              </Drawer>
              <Drawer 
                id='layer_legends'
                sx={styles.poiDrawer}
                aria-labelledby="modal-zone-title"
                role="dialog" 
                aria-modal="true"
                anchor='right'
                variant='persistent'
                open={isMobile && showLegend}
                onClose={() =>  dispatch(setOpenDrawer(false))}
              >
                <LegendContainer allResults={allResults} status={status} />
              </Drawer>
            </Box>
          </MapProvider>
        </div>
      </I18nextProvider>
    </ThemeProvider>
  );
  
}

export default App;
